import React, { memo, useEffect, useState } from 'react'
import { Box, Container, Fab, Grid, LinearProgress, makeStyles, withStyles } from '@material-ui/core';
import normalise from '../utils/NormalizeProgress';
import IconDiceButton from './IconDiceButton';
import GameComponent from './GameComponent';
import ComponentToolbar from './ComponentToolbar';
import MasterInventory from './MasterInventory';
import MasterSkills from './MasterSkills';
import Dices from './Dices';

import CloseIcon from '@material-ui/icons/Close';

// import ReactDOM from 'react-dom';


const useStyles = makeStyles((theme) => ({
  root: {
    transform: 'rotateX(180deg)',
  },
  background: {
    background: 'rgba(0,0,0,0.2)',
  },
  logo: {
    display: 'flex',
    width: '500px',
    justifyContent: 'center',
    margin: 'auto',
    marginBottom: '10px'
  },
  divGridDiceList: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    marginBottom: '40px',
    marginTop: '40px',
    border: '2px solid white',
    height: 'auto',
  },
  statsBar: {
    width: '15rem',
  },
  logo: {
    display: 'flex',
    width: '500px',
    justifyContent: 'center',
    margin: 'auto',
    marginBottom: '10px'
  },
  loadingPage: {
    minHeight: '100vh'
  },
  ficha: {
    backgroundImage: 'linear-gradient(to right bottom, #2e2e2e, #2c2c2c, #2a2a2a, #292929, #272727, #282829, #29282c, #2b292e, #312c34, #382e39, #40313e, #483341)',
    position: 'relative',
  },
  container: {
    color: 'rgb(255, 255, 255)',
  },
  status: {
    /* display: flex; */
    textAlign: 'right',
    /* align-items: center; */
    marginTop: 'auto',
    marginBottom: 'auto',
    color: 'rgb(223, 142, 244)',
  },

  ability: {
    textAlign: 'left',
    margiTop: 'auto',
    margiBottom: 'auto',
    color: 'rgb(242, 122, 122)',

    '&h3': {
      display: 'flex',
    }
  },

  grid: {
    display: 'grid',
    gridColumnGap: '30px',
    gridTemplateColumns: 'auto 300px auto',
  },

  center: {
    /* margin: auto; */
    textAlign: 'center',
    color: 'white'
  },

  info: {
    '& > h2': {
      margin: '0',
      marginTop: '10px',
      color: 'rgb(121, 129, 251)',
    },
    '& > h1': {
      margin: '0'
    }
  },

  others: {
    '& > h2': {
      margin: '0',
      marginTop: '10px',
      color: 'rgb(173, 251, 121)',
    },
    '& > h1': {
      margin: '0'
    }
  },

  profileDiv: {
    width: '90%',
    maxWidth: '370px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },

  profilePic: {
    borderRadius: '50%',
    border: '3px solid rgb(255, 255, 255)',

    objectFit: 'cover',
    objectPosition: 'center center',
    width: '100%',

    aspectRatio: '1/1',
  },

  closeButton: {
    // display: 'flow-root',
    position: 'absolute',
    // float: 'right',
    // left: '100%',
    // top: 0,
  }
}));

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[700],
  },
  bar: {
    // borderRadius: 5,
    backgroundImage: 'radial-gradient(circle, rgba(255, 255, 255, 0.5) 0%, rgba(223, 142, 244,1) 100%)',
  },
}))(LinearProgress);

function PlayerCard({ player, deleteComponent }) {

  const classes = useStyles();

  const { attributes, id, info, other, stats } = player

  const [inventory, setInventory] = useState(player.inventory)
  // useEffect(() => {
  //   setInventory(player.inventory)
  // }, [player.inventory])

  const [skills, setSkills] = useState(player.skills)

  return (
    <Grid item xs={12} className={classes.root}>
      <div className={classes.background}>

        <Fab className={classes.closeButton} color="secondary" aria-label="add" onClick={() => deleteComponent(id)}>
          <CloseIcon />
        </Fab>

        <Box className={classes.profileDiv}>
          <img alt={'photo ' + info.nome} src={info.image} className={classes.profilePic} />
        </Box>




        <Grid
          // className={classes.grid}
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={4}
        >


          <Grid
            item
            className={classes.status}
          // container
          // alignItems="flex-end"
          // direction="column"
          // xs={12}
          >


            <h2>{stats.vida} - Vida</h2>
            <BorderLinearProgress className={classes.statsBar} variant="determinate" value={normalise(stats.vida, stats.vida_max)} />

            <h2>{stats.sanidade} - Sanidade</h2>
            <BorderLinearProgress className={classes.statsBar} variant="determinate" value={normalise(stats.sanidade, stats.sanidade_max)} />

            <h2>{stats.exposicao_paranormal} - E. Paranormal</h2>
            <BorderLinearProgress className={classes.statsBar} variant="determinate" value={normalise(stats.exposicao_paranormal, stats.exposicao_paranormal_max)} />
          </Grid>



          <Grid
            className={classes.ability}
            item
          // xs={12}
          >
            <h3>Aparência - {attributes.aparencia}</h3>
            <h3>Constituição - {attributes.constituicao} <IconDiceButton skillName={"Constituição"} skillValue={attributes.constituicao} /></h3>
            <h3>Destreza - {attributes.destreza} <IconDiceButton skillName={"Destreza"} skillValue={attributes.destreza} /></h3>
            <h3>Força - {attributes.forca} <IconDiceButton skillName={"Força"} skillValue={attributes.forca} /></h3>
            <h3>Inteligência - {attributes.inteligencia} <IconDiceButton skillName={"Inteligência"} skillValue={attributes.inteligencia} /></h3>
            <h3>Poder - {attributes.poder} <IconDiceButton skillName={"Poder"} skillValue={attributes.poder} /></h3>
            <h3>Sorte - {attributes.sorte} <IconDiceButton skillName={"Sorte"} skillValue={attributes.sorte} /></h3>
            <h3>Movimento - {attributes.movimento}</h3>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          <Grid item xs={12}>
            <GameComponent >
              <ComponentToolbar title={'Informações'}>
              </ComponentToolbar>

              <Box className={`${classes.center} ${classes.info}`}>
                <h2>Nome</h2>
                <h1>{info.nome}</h1>
                <h2>Jogador</h2>
                <h1>{info.jogador}</h1>
                <h2>Idade</h2>
                <h1>{info.idade}</h1>
                <h2>Sexo</h2>
                <h1>{info.sexo}</h1>
              </Box>
            </GameComponent>
          </Grid>


          <Grid item xs={12}>
            <GameComponent item>
              <ComponentToolbar title={'Outros'}>
              </ComponentToolbar>

              <Box className={`${classes.center} ${classes.others}`}>
                <h2>Carreira</h2>
                <h1>{other.carreira}</h1>
                <h2>Pessoas Importantes</h2>
                <h1>{other.pessoas_importantes}</h1>
                <h2>Percences Queridos</h2>
                <h1>{other.percences_queridos}</h1>
                <h2>Locais Importantes</h2>
                <h1>{other.locais_importantes}</h1>
              </Box>
            </GameComponent>
          </Grid>
        </Grid>




        <GameComponent>
          <MasterInventory inventory={player.inventory} />
        </GameComponent>

        <GameComponent>
          <MasterSkills skills={player.skills} />
        </GameComponent>

        {/* <Dices /> */}
      </div>
    </Grid>
  )
}

export default PlayerCard
